import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";

@Component({
  selector: 'app-listado-sistema',
  templateUrl: './listado-sistema.component.html',
  styleUrls: ['./listado-sistema.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class ListadoSistemaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  abrirPopUpSistema: boolean = false;
  user: any;
  ipAddress: any;
  repSistemas: any = [];
  loading: boolean = false;
  data: any = {};

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  displayedColumns: string[] =
    ['Checked', 'Sistema', 'Descripcion', 'Arquitectura', 'Estado'];

  dataSource = new MatTableDataSource(this.repSistemas);

  constructor(private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.data.NombreProyecto = 'DigitalFactoring';
    this.data.Usuario = this.user.Usuario;
    this.data.Host = 'INTRANET';
    this.data.IP = this.ipAddress.ip;
    this.data.Canal = 'W';
  }

  ngOnInit() {
    this.ObtenerListaSistemas();
  }

  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        this.dataSource = new MatTableDataSource(this.repSistemas);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }
  AgregarSistema() {
    this.securityService.dataSistema = '';
    this.abrirPopUpSistema = true;
  }

  bloquear(element: any) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de bloquear el sistema ' + element.id_sistemas + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, bloquear sistema',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.data.id_sistemas = element.id_sistemas;
        this.data.Estado = '2';
        this.securityService.EliminarSistema(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡Sistema bloqueado!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              this.redirectOnInit(resp);
            });

          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE BLOQUEÓ SISTEMA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }

  desbloquear(element: any) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de desbloquear el sistema ' + element.id_sistemas + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, desbloquear sistema',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.data.id_sistemas = element.id_sistemas;
        this.data.Estado = '1';
        this.securityService.EliminarSistema(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡Sistema desbloqueado!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              this.redirectOnInit(resp);
            });

          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE DESBLOQUEÓ SISTEMA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }

  EliminarSistema(element: any) {

    this.data.id_sistemas = element.id_sistemas;
    this.data.Estado = '0';

    Swal.fire({
      title: '',
      text: '¿Estás seguro de eliminar el id: ' + element.id_sistemas + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Eliminando Información',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();
        this.securityService.EliminarSistema(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡El sistema se ha eliminado!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              this.redirectOnInit(resp);
            });
          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE ELIMINÓ SISTEMA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    })
  }

  redirectOnInit(resp: SweetAlertResult) {
    if (resp.value) {
      this.ngOnInit();
    }
  }

  EditarSistema(elemento: any) {
    this.securityService.dataSistema = elemento;
    this.abrirPopUpSistema = true;
  }

  CerrarPopUpSistema() {
    this.abrirPopUpSistema = false;
  }

  Refresh() {
    this.ngOnInit();
  }
}
